<template>
    <div class="HeroStart">
        <!-- Desktop -->
        <div class="ZeroStart">
            <div class="laatikko" v-bind:class="{ auki: this.$route.name == 'Immateriaalioikeudet' }" v-on:click="openModule(0)">
                {{ $t('navbar.imateriaalioikeudet', currentLocale) }}
                <div class="kahva"></div>
                <img class="icon-suoritettu" src="../../assets/icons/icon-suoritettu.png" alt="" v-show="isCompleted(9)">
            </div>
            <div class="laatikko" v-bind:class="{ auki: this.$route.name == 'MitaTekijanoikeusTarkoittaa'  }" v-on:click="openModule(1)">
                {{ $t('navbar.tekijanoikeudet', currentLocale) }}
                <div class="kahva"></div>
                <img class="icon-suoritettu" src="../../assets/icons/icon-suoritettu.png" alt="" v-show="isCompleted(25)">
            </div>
            <div class="laatikko" v-bind:class="{ auki: this.$route.name == 'TekijanoikeuksienLuovuttaminen'  }" v-on:click="openModule(2)">
                {{ $t('navbar.luovuttaminen', currentLocale) }}
                <div class="kahva"></div>
                <img class="icon-suoritettu" src="../../assets/icons/icon-suoritettu.png" alt="" v-show="isCompleted(26)">
            </div>
            <div class="laatikko" v-bind:class="{ auki: this.$route.name == 'TeostenKaytto' }" v-on:click="openModule(3)">
                {{ $t('navbar.kaytto', currentLocale) }}
                <div class="kahva"></div>
                <img class="icon-suoritettu" src="../../assets/icons/icon-suoritettu.png" alt="" v-show="isCompleted(27)">
            </div>
            <div class="laatikko" v-bind:class="{ auki: this.$route.name == 'OmanTuottamisenProsessi' }" v-on:click="openModule(4)">
                 {{ $t('navbar.oma', currentLocale) }}
                <div class="kahva"></div>
                <img class="icon-suoritettu" src="../../assets/icons/icon-suoritettu.png" alt="" v-show="isCompleted(28)">
            </div>
        </div>
    </div>

</template>
<script>
  import Modal from '@/views/components/Modal'
  import secretStore from '../../utils/localstorage'

  export default {
    name: 'HeroStart',
    components: {
      Modal
    },
    data: function () {
      return {
        paths: [
          'immateriaalioikeudet',
          'mitatekijanoikeustarkoittaa',
          'tekijanoikeuksienluovuttaminen',
          'teostenkaytto',
          'omantuottamisenprosessi'
        ],
        isActive: [],
        currentIndex: 0
      }
    },
    props: {
      pid: null,
    },
    methods: {
      openModule: function (ind) {
        this.currentIndex = ind
        this.$router.push({path: '/' + this.$route.params.locale + '/' + this.paths[ind]})
        this.isActive = []
        this.isActive[ind] = true
      },
      isCompleted: function (pid) { // implement this in localstore.js
        // console.log( "is completed " + secretStore.getValue(pid) )
        return secretStore.getValue(pid)
      },
      goToNext: function () {
        if( this.currentIndex < this.paths.length-1 ){
          this.openModule (this.currentIndex+1)
        }
        else{
          this.openModule (0)
        }
      }
    },
    computed: {
        currentLocale() {
            return this.$route.params.locale
        },
    },
    mounted: function () {
      // console.log( this.$route.name )
    }
  }


</script>
<style lang="scss">
    .ZeroStart {
        display:flex;
        padding:1rem 0.5rem 0.75rem;
        justify-content: space-around;
        background:url(../../assets/navi-desktop.png);
        background-size:cover;
        background-repeat: no-repeat;
        text-align: center;
        line-height:1rem;
        text-transform: uppercase;
        font-size:16px;
        letter-spacing: 1px;
        font-weight:bold;
        .laatikko {
            position: relative;
            border-radius:5px;
            border:2px solid #906f37;
            margin:0 0.5rem;
            width:20%;
            float:left;
            color:white;
            background:#b5843e;
            height:90px;
            padding:1rem;
            &:hover, &.auki {
                background:#865721;
                .kahva {
                    box-shadow:0 2px 1px #a6722d;
                }
            }
            .kahva {
                width:80px;
                height:10px;
                margin:0 auto;
                position: absolute;
                left:0;
                right:0;
                bottom:15px;
                border-radius:5px;
                box-shadow:0 2px 1px #e1ad55;
                background:#422d19;
            }
            .icon-suoritettu {
                width:32px;
                position: absolute;
                right:5px;
                bottom:5px;
            }
        }

    }
    @media(max-width:1199px) {
        .ZeroStart {
            font-size:12px;
            .laatikko {

            }
        }
    }
    @media(max-width:991px) {
        .ZeroStart {
            background:url(../../assets/navi-mobil.png);
            background-size:cover;
            background-repeat: no-repeat;
            flex-direction: column;
            align-items: center;
            font-size:14px;
            .laatikko {
                padding:0rem;
                width:100%;
                height:45px;
                margin:0.25rem 0;
                display:flex;
                align-items: center;
                justify-content: center;
                .kahva {
                   display:none;
                }
                .icon-suoritettu {
                    width:28px;
                    position: absolute;
                    right:5px;
                    bottom:5px;
                }
            }
        }
    }

    .navi-text {
        font-family: 'Lato';
        font-size: 22px;
        text-transform: uppercase;
        fill: #ffffff;
    }

    .cls-1,
    .cls-7 {
        fill: none;
    }

    .cls-2 {
        isolation: isolate;
    }

    .cls-3 {
        fill: #e1ad55;
    }

    .cls-4 {
        fill: #f4c37d;
    }

    .cls-5 {
        clip-path: url(#clip-path);
    }

    .cls-6 {
        opacity: 0.25;
        mix-blend-mode: screen;
    }

    .cls-7 {
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 2px;
    }

    .raami {
        fill: #906f37;
    }

    .tausta {
        fill: #b5843e;
    }

    .kahva {
        fill: #422d19;
    }

    .kahvatausta {
        fill: #e1ad55;
    }

    .laatikko {
        cursor: pointer;
        &:hover, &.auki {
            .raami {
                fill: #6a491d;
            }
            .tausta {
                fill: #865721;
            }
            .kahva {
                fill: #311e0d;
            }
            .kahvatausta {
                fill: #a6722d;
            }
        }
    }

    .cls-11 {
        fill: #6a491d;
    }

    .cls-12 {
        fill: #865721;
    }

    .cls-13 {
        fill: #a6722d;
    }

    .cls-14 {
        fill: #311e0d;
    }

    .cls-15 {
        fill: #c1e7f5;
    }

    .cls-16 {
        fill: #fff;
    }

    .mobi-1, .mobi-7 {
        fill: none;
    }

    .mobi-2 {
        isolation: isolate;
    }

    .mobi-3 {
        fill: #e1ad55;
    }

    .mobi-4 {
        fill: #f4c37d;
    }

    .mobi-5 {
        clip-path: url(#clip-path);
    }

    .mobi-6 {
        opacity: 0.25;
        mix-blend-mode: screen;
    }

    .mobi-7 {
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 2.99px;
    }

    .mobi-8 {
        fill: #1a1a1a;
        opacity: 0.4;
        mix-blend-mode: multiply;

    }

    .mobi-9 {
        fill: #b5843e;
    }

    .mobi-10 {
        fill: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/views/components/HeroStart.vue